export const getDensityStyles = (density: string) => {
  switch (density) {
    case 'compact':
      return {
        chipWidth: 70,
        chipHeight: 25,
        verticalSize: 'small',
        verticalWidth: 120,
        verticalHeight: 25,
        globeSize: 25,
        avatarSize: 24,
        avatarSizePinned: 20,
        iconButtonSize: 20,
        badgeFontSize: 10,
        iconSize: 16,
        avatarSpacing: 'medium',
        size: 'sm',
        avatarMax: 3,
        padding: '0px',
        fontSize: 12,
        height: 30,
        width: 30,
        svgSize: 28,
        labelSize: 8,
        labelChipSize: 6,
        gap: 1,
      } as const
    case 'comfortable':
      return {
        chipWidth: 70,
        chipHeight: 30,
        verticalSize: 'large',
        verticalWidth: 220,
        verticalHeight: 45,
        globeSize: 36,
        avatarSize: 52,
        avatarSizePinned: 24,
        iconButtonSize: 48,
        iconSize: 32,
        avatarSpacing: 'small',
        size: 'lg',
        avatarMax: 2,
        padding: '0px',
        badgeFontSize: 14,
        fontSize: 15,
        height: 68,
        width: 68,
        svgSize: 58,
        labelSize: 13,
        labelChipSize: 11,
        gap: 3,
      } as const
    case 'standard':
    default:
      return {
        chipWidth: 70,
        chipHeight: 30,
        verticalSize: 'medium',
        verticalWidth: 120,
        verticalHeight: 35,
        globeSize: 32,
        avatarSize: 36,
        avatarSizePinned: 24,
        iconButtonSize: 32,
        iconSize: 20,
        avatarSpacing: 'small',
        size: 'md',
        avatarMax: 3,
        padding: '0px',
        badgeFontSize: 13,
        fontSize: 13,
        height: 48,
        width: 48,
        svgSize: 40,
        labelSize: 11,
        labelChipSize: 9,
        gap: 2,
      } as const
  }
}
